/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, signal, Output, EventEmitter, input, effect } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonsComponent } from '@/app/shared/buttons/buttons.component';
import { DesyAngularModule } from 'desy-angular';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectButtonModule } from 'primeng/selectbutton';
import { MultiSelectModule } from 'primeng/multiselect';
import { Location } from '@angular/common';
import { ConfirmationService } from 'primeng/api';
import { getError } from '@/app/utils/form-errors';
import { AiSystemDeployment, Step1Deployment } from '@/app/interfaces/aiSystemDeployment';
import { setupRequiredValidationBySignal } from '../helpers/validation.helper';

@Component({
  selector: 'app-deploy-system-of-ia-step-1',
  templateUrl: './deploy-system-of-ia-step-1.component.html',
  styleUrls: ['./deploy-system-of-ia-step-1.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AutoCompleteModule,
    ButtonsComponent,
    DesyAngularModule,
    DatePickerModule,
    SelectButtonModule,
    MultiSelectModule,
  ],
  providers: [ConfirmationService],
})
export class DeploySystemOfIaStep1Component {
  @Output() stepCompleted = new EventEmitter<Step1Deployment>();

  // El componente recibe los datos existentes del despliegue de IA (en caso de que existan)
  existingData = input<Partial<AiSystemDeployment>>();

  form: FormGroup;
  getError = getError;

  formSubmitted = signal(false);
  highRiskFieldsRequired = signal(false);

  constructor(
    private fb: FormBuilder,
    private location: Location
  ) {
    this.form = this.fb.group({
      biases: [null, Validators.maxLength(1000)],
      risks: [null, Validators.maxLength(1000)],
    });

    setupRequiredValidationBySignal(this.form, this.highRiskFieldsRequired, ['biases', 'risks']);

    // Si existian datos previos del despliegue de IA, se muestran en el formulario
    effect(() => {
      const data = this.existingData();
      if (data) {
        this.form.patchValue(data);
      }
      // Revisamos el nivel de riesgo para ajustar las validaciones
      const isHighRisk = data.systemClassification === 'alto';
      this.highRiskFieldsRequired.set(isHighRisk);
    });
  }

  async onSave() {
    const formData = this.form.value;
    this.stepCompleted.emit(formData);
  }

  cancel(): void {
    this.location.back();
  }

  confirm() {
    this.formSubmitted.set(true);
    this.onSave();
  }
}
